import {
  ComboBox,
  ComboBoxButton,
  ComboBoxGroup,
  ComboBoxInput,
  ComboBoxListBox,
  ComboBoxListItem,
  ComboBoxPopover,
} from "@/components/combobox";
import { Input } from "@/components/field";
import { Label } from "@/components/field";
import { LabeledGroup } from "@/components/field";
import { Text } from "@/components/text";

import { prefixes } from "../utils/phonePrefixes";

export function PhoneInput({
  label = "Phone number",
  onPhoneChange,
  onPrefixChange,
  phoneValue,
  requiredHint = true,
  selectedPrefix,
}: {
  label?: string;
  onPhoneChange: (value: string) => void;
  onPrefixChange: (key: string) => void;
  phoneValue: string;
  requiredHint?: boolean;
  selectedPrefix: string;
}) {
  const data = prefixes();

  return (
    <LabeledGroup className="w-full">
      <Label requiredHint={requiredHint}>{label}</Label>
      <div className="flex w-full">
        <ComboBox
          allowsEmptyCollection
          aria-label="Prefix"
          menuTrigger="input"
          onSelectionChange={(key) => onPrefixChange(key as string)}
          selectedKey={selectedPrefix}
          style={{ width: 310 }}
        >
          <ComboBoxGroup>
            <ComboBoxInput
              placeholder="Select prefix"
              style={{
                borderBottomRightRadius: "none",
                borderTopRightRadius: "none",
                left: 1,
                MozBorderRadiusBottomright: "none",
                position: "relative",
              }}
            />
            <ComboBoxButton />
          </ComboBoxGroup>
          <ComboBoxPopover>
            <ComboBoxListBox
              aria-label="Prefix"
              renderEmptyState={() => (
                <Text className="p-2">No results found</Text>
              )}
            >
              {data.map((type) => (
                <ComboBoxListItem
                  id={`${type.name}-${type.id}`}
                  key={type.name}
                >
                  {type.name}
                </ComboBoxListItem>
              ))}
            </ComboBoxListBox>
          </ComboBoxPopover>
        </ComboBox>
        <Input
          className="border border-l-0 relative right-2 rounded-tl-none rounded-bl-none"
          onChange={(e) => onPhoneChange(e.target.value)}
          placeholder="Enter phone number"
          value={phoneValue}
        />
      </div>
    </LabeledGroup>
  );
}
